import ApiService from './api.service'

const BillingService = {
  // Fetch billing profiles (usually only one)
  index () {
    return ApiService.get('api/core/billing-profiles')
  },
  // Get a single billing profile by ID
  show (id) {
    return ApiService.get(`api/core/billing-profiles/${id}`)
  },
  // Update a billing profile by ID
  update (id, data) {
    return ApiService.putWithoutLoading(`api/core/billing-profiles/${id}`, data)
  },
  // Stripe: create setup intent for a billing profile
  createSetupIntent (id) {
    return ApiService.postWithoutLoading(`api/core/billing-profiles/${id}/stripe/setup-intent`)
  },
  // Stripe: set default payment method for a billing profile
  setDefaultPaymentMethod (id, paymentMethod) {
    return ApiService.postWithoutLoading(`api/core/billing-profiles/${id}/stripe/default-payment-method`, { paymentMethod })
  },
  // Games played per pre-paid lot and per tier of a billing profile's plan (plan_id, term_id, from, to)
  usageStats (id, params = {}) {
    return ApiService.get(`api/core/billing-profiles/${id}/usage-stats`, { params, headers: { withoutLoading: true } })
  },
  // List invoices (paginated)
  invoices (params = {}) {
    return ApiService.get('api/core/invoices', { params })
  },
  // Download invoice PDF
  download (invoice) {
    return ApiService.get(`api/core/invoices/${invoice}/download`, { responseType: 'blob', headers: { withoutLoading: true } })
  },
  // Download the receipt PDF of a paid invoice
  downloadReceipt (invoice) {
    return ApiService.get(`api/core/invoices/${invoice}/receipt`, { responseType: 'blob', headers: { withoutLoading: true } })
  }
}

export default BillingService
